import shopifyHttpGateway from '@src/services/shopifyHttpGateway';

export const _sendCreateCart = async () => {
  return await shopifyHttpGateway.post({
    query: `
          mutation CreateCart {
            cartCreate {
              cart {
                checkoutUrl
                id
              }
            }
          }
        `,
  });
};

export const _addItemToCart = async ({
  cartId,
  variantId,
  topic,
  subject,
  grade,
  forUser,
  byUser,
  topicKey,
  selectedTime,
  timeKey,
  dayKey,
  subjectKey,
  gradeKey,
  forUserKey,
  byUserKey,
}) => {
  let query = null;

  if (topic && forUser) {
    query = `
          mutation AddToCart {
              cartLinesAdd(cartId: "${cartId}", lines: [{ 
                quantity: 1,
                merchandiseId: "${variantId}",
                attributes: [{ key: "${topicKey}", value: "${topic}"  }, { key: "${subjectKey}", value: "${subject}"}, { key: "${gradeKey}", value: "${grade}"}, { key: "${timeKey}", value: "${selectedTime.time}:00" }, { key: "${dayKey}", value: "${selectedTime.day}" }, { key: "${forUserKey}", value: "${forUser}" }, { key: "${byUserKey}", value: "${byUser}" }]
              }]) {
                cart {
                  lines(first: 100) {
                    edges {
                      node {
                        id
                        quantity
                        merchandise {
                          ... on ProductVariant {
                            product {
                              title
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `;
  } else if (topic) {
    query = `
          mutation AddToCart {
              cartLinesAdd(cartId: "${cartId}", lines: [{ 
                quantity: 1,
                merchandiseId: "${variantId}",
                attributes: [{ key: "${topicKey}", value: "${topic}"  }, { key: "${subjectKey}", value: "${subject}"}, { key: "${gradeKey}", value: "${grade}"}, { key: "${timeKey}", value: "${selectedTime.time}:00" }, { key: "${dayKey}", value: "${selectedTime.day}" }, { key: "${byUserKey}", value: "${byUser}" }]
              }]) {
                cart {
                  lines(first: 100) {
                    edges {
                      node {
                        id
                        quantity
                        merchandise {
                          ... on ProductVariant {
                            product {
                              title
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `;
  } else if (timeKey && selectedTime?.time && selectedTime?.day) {
    query = `
    mutation AddToCart {
        cartLinesAdd(cartId: "${cartId}", lines: [{ 
          quantity: 1,
          merchandiseId: "${variantId}",
          attributes: [{ key: "${timeKey}", value: "${selectedTime.time}:00" }, { key: "${dayKey}", value: "${selectedTime.day}" }]
        }]) {
          cart {
            lines(first: 100) {
              edges {
                node {
                  id
                  quantity
                  merchandise {
                    ... on ProductVariant {
                      product {
                        title
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
  } else {
    query = `
          mutation AddToCart {
              cartLinesAdd(cartId: "${cartId}", lines: [{ 
                quantity: 1,
                merchandiseId: "${variantId}",
              }]) {
                cart {
                  lines(first: 100) {
                    edges {
                      node {
                        id
                        quantity
                        merchandise {
                          ... on ProductVariant {
                            product {
                              title
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `;
  }

  return await shopifyHttpGateway.post({ query });
};
export const _getCartItems = async ({ cartId, locale }) => {
  return await shopifyHttpGateway.post({
    query: `
          query GetCart @inContext(language: ${locale}) {
                cart(id: "${cartId}") {
                  checkoutUrl
                  estimatedCost {
                    subtotalAmount {
                      amount
                      
                    }
                    totalAmount {
                      amount
                      
                    }
                  }
                  lines(first: 100) {
                    edges {
                      node {
                        id
                        quantity
                        attributes {
                          key, 
                          value
                        }
                        estimatedCost {
                          subtotalAmount {
                            amount
                            currencyCode
                          }
                          totalAmount {
                            amount
                            currencyCode
                          }
                        }
                        merchandise {
                          ... on ProductVariant {
                            id
                            title
                            product {
                              id
                              title
                              productType
                              featuredImage {
                                id
                                url (transform: { maxWidth: 76 })
                              }
                              subject: metafield (key: "subject", namespace: "material") {
                                value
                              }
                              format: metafield (key: "format", namespace: "material") {
                                value
                              }
                              vendor
                            }
                            priceV2 {
                              amount
                              currencyCode
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
          `,
  });
};

export const _removeItemFromCart = async ({ cartId, lineId }) => {
  return await shopifyHttpGateway.post({
    query: `
        mutation cartLinesRemove {
          cartLinesRemove(cartId: "${cartId}", lineIds: ["${lineId}"]) {
            cart {
              lines(first: 100) {
                edges {
                  node {
                    id
                    quantity
                    merchandise {
                      ... on ProductVariant {
                        product {
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `,
  });
};

export const _getCheckoutUrl = async ({ cartId }) => {
  const data = await shopifyHttpGateway.post({
    query: `
        query checkoutURL {
          cart(id: "${cartId}") {
            checkoutUrl
          }
        }
      `,
  });

  if (!data) {
    return false;
  }
};

export const _updateCartIdentity = async ({ cartId, token }) => {
  return await shopifyHttpGateway.post({
    query: `
      mutation {
        cartBuyerIdentityUpdate(
          cartId: "${cartId}"
          buyerIdentity: {
            customerAccessToken: "${token}"
          }
        ) {
          cart {
            id
            buyerIdentity {
              email
              phone
              countryCode
            }
          }
        }
      }
    `,
  });
};
